import React from "react";
import { Info } from "./CooperativeDetails";
import { ICooperativeDetails } from "../../exports/interfaces";
import useMobile from "../../hooks/useMobile";
import { Pencil } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { usePermission } from "../../hooks/usePermission";

const CooperativeInfo = ({
  cooperative,
}: {
  cooperative: ICooperativeDetails | null;
}) => {
  const isMobile = useMobile();
  const { canEdit } = usePermission();
  const navigate = useNavigate();
  return (
    <>
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h6 className="primary-color">Cooperatives Basic Info</h6>
        {canEdit("cooperatives") && (
          <button
            className="btn px-3 btn-badge fs-small"
            onClick={() =>
              navigate(`/register/edit/${cooperative?.id}`, {
                state: {
                  step: 0,
                },
              })
            }
          >
            <i className={`${!isMobile ? "me-2" : ""}`}>
              <Pencil size={15} />
            </i>
            {!isMobile && "Edit"}
          </button>
        )}
      </div>

      <div className="row g-3">
        <div className="col-md-12 details-text">
          <small className="d-block">Registration Number</small>
          <p>{cooperative?.registrationNumber}</p>
        </div>
        <Info
          label="Cooperative Name in Nepali"
          value={cooperative?.nameNepali || "-"}
        />

        <Info
          label="Cooperative Name in English"
          value={cooperative?.nameEnglish || "-"}
        />

        <Info
          label="Cooperative PAN Number"
          value={cooperative?.panNumber || "-"}
        />

        <Info label="Mobile Number" value={cooperative?.mobileNumber || "-"} />

        <Info label="Contact Email" value={cooperative?.email || "-"} />

        <Info
          label="Contact Person"
          value={cooperative?.contactPerson || "-"}
        />
        <Info
          label="Cooperative Registered Date (Nepali)"
          value={cooperative?.registeredDate || "-"}
        />

        <Info label="Registered At" value={cooperative?.registeredAt || "-"} />
        <Info
          label="Registered Office Address"
          value={cooperative?.registeredOfficeAddress || "-"}
        />
        <Info
          label="Is Registered in Federation?"
          value={
            cooperative?.isRegisteredInFederation === true
              ? "Yes"
              : cooperative?.isRegisteredInFederation === false
                ? "No"
                : "-"
          }
        />
        <Info
          label="Cooperative Types"
          value={cooperative?.natureOfWork || "-"}
        />

        <Info
          label="Name of the Software Used"
          value={cooperative?.softwareUsed || "-"}
        />
        <Info
          label="Current Working Staffs"
          value={cooperative?.staffCount ?? "-"}
        />
      </div>
      <hr />
    </>
  );
};

export default CooperativeInfo;
